// used from cph-epi\src\Cph.Website\Views\SearchResultsPage\Index.cshtml
import { ActivateSpinner, DeactivateSpinner } from "./Spinner"
import { generalSearch } from "./general-search"

const searchResultsPage = {
  pageReference: null,
  originalQuery: null,
  showMoreUrl: null,
  currentTab: null,
  totalTabShowMorePresses: null,
  productTabShowMorePresses: null,
  articleTabShowMorePresses: null,
  shopTabShowMorePresses: null,
  brandTabShowMorePresses: null,
  prefType: null,
  init: function () {
    console.debug("searchResultsPage:init")

    const searchContainer = document.querySelector("[data-search-result-page]")
    if (searchContainer) {
      const config = (searchContainer.dataset.searchResultPage && JSON.parse(searchContainer.dataset.searchResultPage)) || {}
      const pageRef = config.pageRef
      const query = config.query
      const moreUrl = config.moreUrl
      const typeString = config.typeString

      this.pageReference = pageRef
      this.originalQuery = query
      this.showMoreUrl = moreUrl
      this.prefType = typeString
      this.totalTabShowMorePresses = { count: 1 }
      this.productTabShowMorePresses = { count: 1 }
      this.articleTabShowMorePresses = { count: 1 }
      this.shopTabShowMorePresses = { count: 1 }
      this.brandTabShowMorePresses = { count: 1 }
      this.setupSearchListeners()
    }
  },

  setupSearchListeners: function () {
    const accordionTriggers = document.querySelectorAll(".tab-panes__content .js--accordion-trigger")
    accordionTriggers?.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        this.showMore()
      })
    })

    const formFields = document.querySelectorAll("form.js-search-result-page-form")
    formFields?.forEach((field) => {
      field.addEventListener("submit", function (event) {
        console.log("formFields submit")
        event.preventDefault()
        const query = this.querySelector('input[type="text"]').value
        generalSearch.search(query, this.prefType)
      })
    })
  },

  showMore: function () {
    ActivateSpinner()
    let showMoreRef
    const activeTabInnerContent = document.querySelector("div.tab-panes__content__inner.is-active")
    const currenContentId = activeTabInnerContent?.dataset.contentid
    switch (currenContentId) {
      case "0":
        showMoreRef = this.totalTabShowMorePresses
        break
      case "1":
        showMoreRef = this.productTabShowMorePresses
        break
      case "2":
        showMoreRef = this.articleTabShowMorePresses
        break
      case "3":
        showMoreRef = this.shopTabShowMorePresses
        break
      default:
        showMoreRef = this.brandTabShowMorePresses
        break
    }

    const queryObject = {
      ContentReference: this.pageReference,
      Query: this.originalQuery,
      ShowMorePresses: showMoreRef.count,
      CurrentTab: currenContentId,
      Type: this.prefType,
    }

    fetch(this.showMoreUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(queryObject),
    })
      .then((response) => response.json())
      .then((result) => {
        const showMoreButton = activeTabInnerContent?.lastElementChild
        showMoreButton.insertAdjacentHTML("beforebegin", result.view)
        showMoreRef.count = result.showMorePresses
        if (result.allResultsShown) {
          showMoreButton.remove()
        }
      })
      .catch((error) => {
        console.log("showMore error", this.showMoreUrl, error)
      })
      .finally(() => {
        DeactivateSpinner()
      })
  },
}
searchResultsPage.init()
